import axios from 'axios';
import { MDBCountdown, MDBCountdownUnit } from 'mdb-react-countdown';
import { MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog } from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserProfileContext } from './components/context/UserProfileProvider';
import { CartContext } from './components/context/CartProvider';
import { NavbarContext } from './components/context/NavProvider';
import { CategoryContext } from './components/context/CategoryContext';
import { DomainContext } from './components/context/DomainProvider';
import { GeographyContext } from './components/context/GeographyProvider';
import { MiscContext } from './components/context/MiscProvider';

const ClearDataButton = ({isSideNav}) => {
  const [showModal, setShowModal] = useState(false);
  const [inactivityTimer, setInactivityTimer] = useState(null);
  const navigate = useNavigate(); // get the navigate function
  
  const getApiUrl = (path) => {
    const authUrl = process.env.REACT_APP_AUTH_URL;
    return `${authUrl}${path}`;
  };
  const [defaultDate, setDefaultDate] = useState(new Date());  // Initialize with the current date 
  const SESSION_EXPIRY_DURATION = 30 * 60 * 10000; // 30 minutes
  const SHOW_MODAL_BEFORE_EXPIRY = 90 * 1000; // 90 seconds
  
  const TIME_TO_SHOW_MODAL = SESSION_EXPIRY_DURATION - SHOW_MODAL_BEFORE_EXPIRY; // This will be 28 minutes 30 seconds
  const MODAL_COUNTDOWN_DURATION = 90 * 1000;
  const handleInterval = () => {   
    setDefaultDate(new Date().getTime()+TIME_TO_SHOW_MODAL);   
  };
  const modalTimeoutRef = useRef(null);
  const handleDismissRef = useRef(null);

  const {setForgotUserIdModalOpen,setDynamicMessageFromApiCall,  setPp,clearMiscState, setContactPage,setDPM,pageData, setPwdAlert,setForgotPasswordModalOpen, setTestimonials, setAlertMessage,  setDocumentsMap,setCompaniesMap,setReceipts, setShowAlert} = useContext(MiscContext);
   const { setAddresses,  setPhones,  setEmails,  setUserProfile ,setUid, setIsLoginRequired,tokenLoaded,setTokenLoaded,setNames,setOriginalNames,setCompanyNames, setImages} = useContext(UserProfileContext); 
  const { setCart, setCartCount, setQty,setCartId, setAddedEntities,setDeliveryDate, setPaymentInfo, setOrders, setOrdersCount} = useContext(CartContext);
  const { setBasicOpen, setIsPricing, setIsDark,setAvatar,setBusiness} = useContext(NavbarContext);
  const {setSelectDomains,  setDomainImages, setDomainData} = useContext(DomainContext);
  const { setIsCategoryFormSubmitted,setSelectCategories,setCategoryImages,setCategoryId} = useContext(CategoryContext);
  const {setIPAddress,setLocation,setStateOptions} = useContext(GeographyContext);

  const clearNetworkData = useCallback(async () => {
    try {
      if ('caches' in window) {
        const cacheKeys = await window.caches.keys();
        const deletePromises = cacheKeys.map(key => window.caches.delete(key));
        await Promise.all(deletePromises);
      } else {
        console.warn('Caches API is not available in this browser.');
      }

      localStorage.removeItem('DOMAIN');
      localStorage.removeItem('FIRM');
      localStorage.removeItem('CART-ID');
      localStorage.removeItem('BUSINESS');
      localStorage.removeItem('pageData');
      localStorage.removeItem('selectDomains');
      localStorage.removeItem('orders');
      localStorage.removeItem('cartCount');
      localStorage.removeItem('selectCategories');
      localStorage.removeItem('categoryImages');
      setDomainImages([]);
      setNames([]);
      setCompanyNames([]);
      setOriginalNames([]); 
      setDomainData([]);
      setAvatar(undefined);
      setIsLoginRequired(false);
      setForgotUserIdModalOpen(false);
      setAddedEntities([]);
      setCartId(undefined);
      setTokenLoaded(false);
      setDynamicMessageFromApiCall(undefined);
      setSelectDomains([]);
      setQty(0);
      setPp(false);
      setSelectCategories([]);
      clearMiscState(true);
      setCategoryImages([]);
      setCartCount(0);
      setCategoryId(undefined);
      setAddresses([]);
      setPhones([]);
      setEmails([]);
      setUserProfile(undefined);
      setCart(undefined);
      setOrders([]);
      setContactPage(undefined);
      setUid(undefined);
      setBasicOpen(false);
      setLocation(undefined);
      setPaymentInfo(undefined);
      setIPAddress(undefined);
      setStateOptions(undefined);
      setDPM(undefined);
      setDeliveryDate(undefined);
      setBusiness('');
      setPwdAlert(false);
      setForgotPasswordModalOpen(false);
      setTestimonials([]);
      setAlertMessage(undefined);
      setIsCategoryFormSubmitted(false);
      setIsPricing(false);
      setIsDark(false);
      setDocumentsMap({});
      setCompaniesMap({});
      setImages([]);
      setReceipts([]);
      setShowAlert(false);
      setOrdersCount(0);
    } catch (error) {
      console.error('Error clearing network data:', error);
    }
  }, []);



  useEffect(() => {
    const handleBeforeUnload = (event) => {
      
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
  
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  const clearData = useCallback(async () => {
    setShowModal(false);
    try {
      const response = await axios.post(
        getApiUrl("/users/logout"), {}, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      if (response.status === 200) {
        // Clearing cookies
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
  
        // Clearing localStorage
        localStorage.removeItem('JWT-TOKEN');
        localStorage.removeItem('DOMAIN');
        localStorage.removeItem('ROLE');
        localStorage.removeItem('AVATAR');
        localStorage.removeItem('FIRM');
        localStorage.removeItem('DPM');
        localStorage.removeItem('CART-ID');
        localStorage.removeItem('SUBSCRIPTION');
        localStorage.removeItem('emails');
        localStorage.removeItem('addresses');
        localStorage.removeItem('phones');
       
      localStorage.removeItem('selectDomains');
      localStorage.removeItem('orders');
      localStorage.removeItem('permissions');
      localStorage.removeItem("groups");
      localStorage.removeItem('cartCount');
      localStorage.removeItem('selectCategories');
      localStorage.removeItem('categoryImages');
      //  localStorage.clear();
       // localStorage.setItem('LOGO', pageData?.logo);
        localStorage.removeItem('pageData');
        setCart(null);
  
        // Clearing cache
        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
        } else {
          console.warn('Caches API is not available in this browser.');
        }
  
        // Clearing axios headers
        delete axios.defaults.headers.common['Authorization'];
  
        // Navigate to home page
        navigate('/home');
      }
    } catch (error) {
      console.error('Error while logging out', error);
      navigate('/home');
    } finally {
      // Clearing any remaining network data and state
      clearMiscState();
      setTokenLoaded(false);
      clearNetworkData();
    }
  }, [pageData?.logo, setCart, navigate, clearMiscState, setTokenLoaded, clearNetworkData]);



// Modify showInactivityModal to use the ref instead of the function directly
const showInactivityModal = useCallback(() => {
    setShowModal(true);
    modalTimeoutRef.current = setTimeout(() => {
        handleDismissRef.current(); // Use the ref here
    }, SHOW_MODAL_BEFORE_EXPIRY);
}, [SHOW_MODAL_BEFORE_EXPIRY]);




// Update the ref whenever handleDismiss changes
const handleDismiss = useCallback(() => {
  if (modalTimeoutRef.current) {
    clearTimeout(modalTimeoutRef.current);
    modalTimeoutRef.current = null;
  }
  setShowModal(false);
  //startInactivityTimer();  // Reset inactivity timer when modal is dismissed
}, []);

// Assign the latest handleDismiss to the ref after defining it
useEffect(() => {
  handleDismissRef.current = handleDismiss;
}, [handleDismiss]);

useEffect(() => {
  const inactivityCheck = setTimeout(() => {
      if (tokenLoaded && !showModal) {
          setShowModal(true);
      }
  }, TIME_TO_SHOW_MODAL);

  return () => {
      clearTimeout(inactivityCheck);
  };
}, [TIME_TO_SHOW_MODAL, tokenLoaded, showModal]);

useEffect(() => {
  if (showModal && tokenLoaded) {
      const endDate = new Date(new Date().getTime() + MODAL_COUNTDOWN_DURATION);
      setDefaultDate(endDate);
      
      modalTimeoutRef.current = setTimeout(() => {
          handleDismiss();
          clearData();
      }, MODAL_COUNTDOWN_DURATION);
  }

  return () => {
      if (modalTimeoutRef.current) {
          clearTimeout(modalTimeoutRef.current);
      }
  };
}, [showModal, tokenLoaded, MODAL_COUNTDOWN_DURATION, handleDismiss, clearData]);


const handleContinueSession = () => {
  if (modalTimeoutRef.current) {
      clearTimeout(modalTimeoutRef.current);
      modalTimeoutRef.current = null;
  }
  setShowModal(false);
  setInactivityTimer(setTimeout(showInactivityModal, TIME_TO_SHOW_MODAL));
};

useEffect(() => {
  const handleBeforeUnload = (event) => {
    // This text won't be shown to the user in most modern browsers
    event.returnValue = "Are you sure you want to leave?";
  };

  const handleUnload = () => {
    // Perform any cleanup that doesn't require user interaction
    clearData(); // You can call your clear data function here
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  window.addEventListener('unload', handleUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    window.removeEventListener('unload', handleUnload);
  };
}, [clearData]);




  return (
    <div>
      
<MDBModal  className='justify-content-center rounded' animationDirection='bottom' open={showModal && tokenLoaded && !isSideNav} nonInvasive tabIndex='-1' frame>
  <MDBModalDialog position='top' frame >
    <MDBModalContent >
      
      <MDBModalBody className='justify-content-center align-items-center gap-3 text-center'>
        <div className='  justify-content-center align-items-center gap-3 text-center'>
          <p className='mb-0 mb-md-2 mb-sm-0 text-center d-flex gap-3 justify-content-center rounded'><span className='mt-2'>Continue the session.. ? </span>
          
          <div className="d-grid gap-2 d-md-flex justify-content-md-end ">
              <MDBBtn size='xs' color='success'  onClick={clearData}>
                No
              </MDBBtn>
              <MDBBtn  color='secondary'  size='xs'  onClick={handleContinueSession}>
                Yes
              </MDBBtn>
        </div>
        {/* <MDBCountdown className='ms-2 mt-3' countdown={defaultDate} onEnd={() => handleInterval()}> */}
        <MDBCountdown className='ms-2 mt-3' countdown={defaultDate} onEnd={() => handleInterval(defaultDate)}>
              
        <div className="d-flex  justify-content-center align-items-center gap-3 mb-2" >
                  <MDBCountdownUnit label='  minutes' type='minutes' />
                  <MDBCountdownUnit label='  seconds' type='seconds' />
                </div>
              </MDBCountdown>

      
        </p>
        </div>
      </MDBModalBody>
    </MDBModalContent>
  </MDBModalDialog>
</MDBModal>

     
      <MDBBtn className='ms-2' tag='a' color='none' floating onClick={clearData} to="/home">
    <MDBIcon fas icon="sign-out-alt" style={{ color: '#ff4500' }}/> 
      </MDBBtn>
      
    </div>
  );
};

ClearDataButton.propTypes = {
  isSideNav:PropTypes.bool,
};

export default ClearDataButton;
